import React, { useCallback } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { approveClient } from '../../../slices/client-voices-slice';

export function AcceptPositionButton(props) {
    const { shortForm } = props;
    const dispatch = useDispatch();
    const { approving } = useSelector((state) => state.clientVoices);
    const handleClick = useCallback(() => {
        dispatch(approveClient());
    }, [dispatch]);
    return (
        <Button onClick={handleClick}>
            {approving && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
            <span>Подтвердить {!shortForm && 'положение'}</span>
        </Button>
    );
}
